document.addEventListener('DOMContentLoaded', function () {
    function initPills(){
      const technicalDataSheetPill = document.querySelector('[data-pill="technical-data-sheet"]');
      const sheetContainer = document.querySelector('.technical-data-sheet-container');

      const manualPill = document.querySelector('[data-pill="technical-manuals"]');
      const manualContainer = document.querySelector('.container-manuals ');

      const catalogPill = document.querySelector('[data-pill="catalog"]');
      const catalogContainer = document.querySelector('.container-catalog ');

      technicalDataSheetPill?.removeEventListener('click', onSheetClick);
      manualPill?.removeEventListener('click', onManualClick);
      catalogPill?.removeEventListener('click', onCatalogClick);

      technicalDataSheetPill?.addEventListener('click', onSheetClick);
      manualPill?.addEventListener('click', onManualClick);
      catalogPill?.addEventListener('click', onCatalogClick);

      function onSheetClick(event){
        event.preventDefault();
        manualContainer?.classList?.add('hidden');
        catalogContainer?.classList?.add('hidden');
        sheetContainer?.classList?.toggle('hidden');
      }
      function onManualClick(event){
        event.preventDefault();
        catalogContainer?.classList?.add('hidden');
        sheetContainer?.classList?.add('hidden');
        manualContainer?.classList?.toggle('hidden');
      }
      function onCatalogClick(event){
        event.preventDefault();
        manualContainer?.classList?.add('hidden');
        sheetContainer?.classList?.add('hidden');
        catalogContainer?.classList.toggle('hidden');
      }
    }

    initPills();

    subscribe(PUB_SUB_EVENTS.variantChange,initPills);
});
